"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _icons = require("../../../static/icons/icons");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Dropdown = function (_React$Component) {
  (0, _inherits2["default"])(Dropdown, _React$Component);

  var _super = _createSuper(Dropdown);

  function Dropdown(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Dropdown);
    _this = _super.call(this, props);

    _this.onClick = function () {
      var expanded = _this.state.expanded;

      _this.setState({
        expanded: !expanded
      });
    };

    _this.state = {
      expanded: props.expanded
    };
    return _this;
  }

  (0, _createClass2["default"])(Dropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          titleComponent = _this$props.titleComponent,
          contentComponentOpen = _this$props.contentComponentOpen,
          contentComponentClose = _this$props.contentComponentClose,
          closedIcon = _this$props.closedIcon,
          openedIcon = _this$props.openedIcon,
          iconSize = _this$props.iconSize;
      var expanded = this.state.expanded;
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_style.CollapseButton, {
        onClick: this.onClick
      }, titleComponent, _react["default"].createElement(_style.CollapseIcon, {
        icon: expanded ? openedIcon : closedIcon,
        size: iconSize
      })), expanded ? contentComponentOpen : contentComponentClose);
    }
  }]);
  return Dropdown;
}(_react["default"].Component);

Dropdown.propTypes = {
  titleComponent: _propTypes["default"].node,
  contentComponentOpen: _propTypes["default"].node,
  contentComponentClose: _propTypes["default"].node,
  closedIcon: _propTypes["default"].node,
  openedIcon: _propTypes["default"].node,
  expanded: _propTypes["default"].bool,
  iconSize: _propTypes["default"].number
};
Dropdown.defaultProps = {
  titleComponent: null,
  contentComponentOpen: null,
  contentComponentClose: null,
  closedIcon: _icons.ICONS.RIGHT,
  openedIcon: _icons.ICONS.DOWN,
  expanded: true,
  iconSize: 12
};
var _default = Dropdown;
exports["default"] = _default;